import { render, staticRenderFns } from "./applicationFormsEn.vue?vue&type=template&id=970f8250&scoped=true&"
import script from "./applicationFormsEn.vue?vue&type=script&lang=ts&"
export * from "./applicationFormsEn.vue?vue&type=script&lang=ts&"
import style0 from "./applicationFormsEn.vue?vue&type=style&index=0&id=970f8250&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "970f8250",
  null
  
)

export default component.exports